import React from "react";

const MailOverview = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#F6F8FA" />
      <path
        d="M13.25 13.75H26.75C26.9489 13.75 27.1397 13.829 27.2803 13.9697C27.421 14.1103 27.5 14.3011 27.5 14.5V25.5C27.5 25.6989 27.421 25.8897 27.2803 26.0303C27.1397 26.171 26.9489 26.25 26.75 26.25H13.25C13.0511 26.25 12.8603 26.171 12.7197 26.0303C12.579 25.8897 12.5 25.6989 12.5 25.5V14.5C12.5 14.3011 12.579 14.1103 12.7197 13.9697C12.8603 13.829 13.0511 13.75 13.25 13.75ZM26 16.9285L20.054 22.2535L14 16.912V24.75H26V16.9285ZM14.3833 15.25L20.0457 20.2465L25.6265 15.25H14.3833Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default MailOverview;
